<template>
<div>
  <section class="hero  is-fullheight">

    <div class="hero-body"><div class="container"> 
      <nav class="level">  
          <div class="level-item has-text-centered" v-for='t in title' :key='t.title'>
            <div>
              <a class="heading" :href='t.link' style="font-size:8em;" v-html="t.icon" :title='"进入" + t.title'></a> 
              <p v-html="t.title"></p>
              <!-- <span v-if="t.alternative"><a :href='t.alternative' title='英文版'>英文版</a></span> -->

              <!-- <a :href='t.pdf' v-if="t.pdf" style="font-size:1em;"><i class="far fa-file-pdf"></i></a> &middot <a :href='t.docx' v-if="t.docx" style="font-size:1em;"><i class="far fa-file-word"></i></a> -->
            </div>
          </div>
      </nav>
    </div></div> 

  </section>

<section>
<div class="chart"></div>
</section>
</div>

</template>

<script>
import md from "../components/mdify.vue";
// import * as d3 from 'd3'


export default {
  mounted(){
// var data = [4, 8, 15, 16, 23, 42];

// var x = d3.scale.linear()
//     .domain([0, d3.max(data)])
//     .range([0, 420]);

// d3.select(".chart")
//   .selectAll("div")
//     .data(data)
//   .enter().append("div")
//     .style("width", function(d) { return x(d) + "px"; })
//     .text(function(d) { return d; });

  },
  data() {
    return {
      mylabel: "TestDataLabel",
      mylabels: ["happy", "myhappy", "hello"],
      mydata: [100, 40, 60],
      title: [
        // {
        //   icon:
        //     "<span class='fa-layers fa-fw'><i class='fas fa-flask'></i><span class='fa-layers-counter' style='background:Tomato'>中</span></span>",
        //   title: "项目经验",
        //   link: "https://tan.netlify.app/?src=projects-zh&loc=zh",
        //   pdf: "https://tan.netlify.app/pdf/projects-zh.pdf",
        //   alternative: "https://tan.netlify.app/docx/projects-zh.docx"
        // },
        // {
        //   icon:
        //     "<span class='fa-layers fa-fw'><i class='far fa-file-alt'></i><span class='fa-layers-counter' style='background:Tomato'>中</span></span>",
        //   title: "中文简历",
        //   link: "https://tan.netlify.app/?src=tom-tan-cv-zh&loc=zh",
        //   pdf: "https://tan.netlify.app/pdf/tom-tan-cv-zh.pdf",
        //   alternative: "https://tan.netlify.app/docx/tom-tan-cv-zh.docx"
        // },
        {
          icon:
            "<span class='fa-layers fa-fw'><i class='far fa-file-powerpoint'></i><span class='fa-layers-counter' style='background:Tomato'>EN</span></span>",
          title: "幻灯片",
          link: "https://tslides.netlify.app/cv"
        },
        {
          icon:
            "<span class='fa-layers fa-fw'><i class='far fa-file-alt'></i><span class='fa-layers-counter' style='background:Tomato'>中</span></span>",
          title: "简历",
          link: "https://tan.netlify.app",
          alternative: "https://tan.netlify.app"
        },
        {
          icon:
            "<span class='fa-layers fa-fw'><i class='fas fa-flask'></i><span class='fa-layers-counter' style='background:Tomato'>中</span></span>",
          title: "部分项目",
          link: "https://tan.netlify.app/?src=projects-zh&loc=zh",
          alternative: "https://tan.netlify.app/?src=projects-en&loc=zh"
        }
      ]
    };
  },
  methods: {
    join(items, sep = " · ") {
      return items ? items.join(sep) : "";
    },

    to_list(items){
      return items.map(i => '- ' + i).join('\n')
    }
  },
  components: {
    md
  }
};
</script>
<style scoped>
.chart div {
  font: 10px sans-serif;
  background-color: steelblue;
  text-align: right;
  padding: 3px;
  margin: 1px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/landing_links.vue